import React, { ReactNode } from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import SettingsSVG from '../../svgs/SettingsSVG';
import ProfileSVG from '../../svgs/ProfileSVG';
import DashboardSVG from '../../svgs/DashboardSVG';
import NewRequestSVG from '../../svgs/NewRequestSVG';
import CustomNavLink from './CustomNavLink';

const RequestorSidebarMenu: React.FC = () => {
    const location = useLocation();
    const { pathname } = location;

    return (
        <>
            <nav className="mt-5 py-4 px-4 lg:mt-9 lg:px-6">

                <div>
                    <h3 className="mb-4 ml-4 text-sm font-semibold text-boxdark dark:text-bodydark2">
                        MENU
                    </h3>

                    <ul className="mb-6 flex flex-col gap-1.5">

                        <li>
                            <CustomNavLink navPath="/request" navPathInclude="/request" isAbsoluteDashboard={false}>
                                <DashboardSVG />
                                Dashboard
                            </CustomNavLink>
                        </li>                       
                        <li>
                            <CustomNavLink navPath="/settings" navPathInclude="settings" isAbsoluteDashboard={false}>
                                <SettingsSVG />
                                Settings
                            </CustomNavLink>                            
                        </li>
                    </ul>

                </div>

            </nav>
        </>
    );
};

export default RequestorSidebarMenu;